import { CmsApiRecommendedJobsBlockData } from 'modules/cms/api/types/CmsApiRecommendedJobs';

import { CmsAmpRecommendedJobs } from './Amp';
import { CmsStandardRecommendedJobs } from './Standard';

type Props = {
  data: CmsApiRecommendedJobsBlockData;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
  context: 'amp' | 'standard';
};

export function CmsRecommendedJobsBlockContent({
  data: { headline, layout, jobFunction },
  source,
  context,
}: Props) {
  if (context === 'amp') {
    return (
      <CmsAmpRecommendedJobs
        headline={headline}
        layout={layout}
        jobFunction={jobFunction}
        source={source}
      />
    );
  }

  return (
    <CmsStandardRecommendedJobs
      headline={headline}
      layout={layout}
      jobFunction={jobFunction}
      source={source}
    />
  );
}
